/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Botica API
 * API for the Botica professional network for Venezuelan pharmacists
 * OpenAPI spec version: v1
 */
import type {
  AdminCredentialDto,
  AdminResetPasswordResponse,
  AdminUserDto,
  AdminUserListResponse,
  CredentialListResponse,
  GetApiAdminCredentialsParams,
  GetApiAdminUsersParams,
  PostApiAdminSeedParams,
  ReviewCredentialRequest
} from '../boticaAPI.schemas';

import { axiosInstance } from '../../axiosInstance';



  export const getAdmin = () => {
const getApiAdminCredentials = (
    params?: GetApiAdminCredentialsParams,
 ) => {
      return axiosInstance<CredentialListResponse>(
      {url: `/api/admin/credentials`, method: 'GET',
        params
    },
      );
    }
  const getApiAdminCredentialsId = (
    id: string,
 ) => {
      return axiosInstance<AdminCredentialDto>(
      {url: `/api/admin/credentials/${id}`, method: 'GET'
    },
      );
    }
  const postApiAdminCredentialsIdReview = (
    id: string,
    reviewCredentialRequest: ReviewCredentialRequest,
 ) => {
      return axiosInstance<AdminCredentialDto>(
      {url: `/api/admin/credentials/${id}/review`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reviewCredentialRequest
    },
      );
    }
  const postApiAdminUsersIdResetPassword = (
    id: string,
 ) => {
      return axiosInstance<AdminResetPasswordResponse>(
      {url: `/api/admin/users/${id}/reset-password`, method: 'POST'
    },
      );
    }
  const getApiAdminUsers = (
    params?: GetApiAdminUsersParams,
 ) => {
      return axiosInstance<AdminUserListResponse>(
      {url: `/api/admin/users`, method: 'GET',
        params
    },
      );
    }
  const getApiAdminUsersId = (
    id: string,
 ) => {
      return axiosInstance<AdminUserDto>(
      {url: `/api/admin/users/${id}`, method: 'GET'
    },
      );
    }
  const postApiAdminUsersIdPromote = (
    id: string,
 ) => {
      return axiosInstance<void>(
      {url: `/api/admin/users/${id}/promote`, method: 'POST'
    },
      );
    }
  const postApiAdminUsersIdDemote = (
    id: string,
 ) => {
      return axiosInstance<void>(
      {url: `/api/admin/users/${id}/demote`, method: 'POST'
    },
      );
    }
  const postApiAdminUsersIdSetFounder = (
    id: string,
 ) => {
      return axiosInstance<void>(
      {url: `/api/admin/users/${id}/set-founder`, method: 'POST'
    },
      );
    }
  const postApiAdminUsersIdRemoveFounder = (
    id: string,
 ) => {
      return axiosInstance<void>(
      {url: `/api/admin/users/${id}/remove-founder`, method: 'POST'
    },
      );
    }
  const postApiAdminUsersIdSetVerifier = (
    id: string,
 ) => {
      return axiosInstance<void>(
      {url: `/api/admin/users/${id}/set-verifier`, method: 'POST'
    },
      );
    }
  const postApiAdminUsersIdRemoveVerifier = (
    id: string,
 ) => {
      return axiosInstance<void>(
      {url: `/api/admin/users/${id}/remove-verifier`, method: 'POST'
    },
      );
    }
  const postApiAdminSeed = (
    params?: PostApiAdminSeedParams,
 ) => {
      return axiosInstance<void>(
      {url: `/api/admin/seed`, method: 'POST',
        params
    },
      );
    }
  return {getApiAdminCredentials,getApiAdminCredentialsId,postApiAdminCredentialsIdReview,postApiAdminUsersIdResetPassword,getApiAdminUsers,getApiAdminUsersId,postApiAdminUsersIdPromote,postApiAdminUsersIdDemote,postApiAdminUsersIdSetFounder,postApiAdminUsersIdRemoveFounder,postApiAdminUsersIdSetVerifier,postApiAdminUsersIdRemoveVerifier,postApiAdminSeed}};
export type GetApiAdminCredentialsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['getApiAdminCredentials']>>>
export type GetApiAdminCredentialsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['getApiAdminCredentialsId']>>>
export type PostApiAdminCredentialsIdReviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminCredentialsIdReview']>>>
export type PostApiAdminUsersIdResetPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminUsersIdResetPassword']>>>
export type GetApiAdminUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['getApiAdminUsers']>>>
export type GetApiAdminUsersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['getApiAdminUsersId']>>>
export type PostApiAdminUsersIdPromoteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminUsersIdPromote']>>>
export type PostApiAdminUsersIdDemoteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminUsersIdDemote']>>>
export type PostApiAdminUsersIdSetFounderResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminUsersIdSetFounder']>>>
export type PostApiAdminUsersIdRemoveFounderResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminUsersIdRemoveFounder']>>>
export type PostApiAdminUsersIdSetVerifierResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminUsersIdSetVerifier']>>>
export type PostApiAdminUsersIdRemoveVerifierResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminUsersIdRemoveVerifier']>>>
export type PostApiAdminSeedResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdmin>['postApiAdminSeed']>>>
